import { apiRequest } from './httpClient';

export async function getIngestionStatus() {
    const body = await apiRequest('/ingestion/status');
    return body.data || body;
}

export async function triggerIngestion(trigger = 'frontend-manual') {
    const body = await apiRequest('/ingestion/trigger', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ trigger })
    });
    return body.data || {};
}
